import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../../components';
import { Button, Grid, Stack, Typography } from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';
import { request } from '../../../../../../utils';
import { toast } from '../../../../../../utils';

export const FrequencyMasterDetailsForm = ({ onClose, setFrequencyDialogue, onAddFrequency, setFrequency }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        frequency: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;

  const formSubmit = async (formValues) => {
    const response = await request('/frequency-master-create', {
      method: 'POST',
      body: {
        frequency: formValues.frequency
      }
    });
    if (response?.success) {
      toast(`Successfully ${'created'}Frequency master`, { variant: 'success' });
      setFrequency((prev) => [...prev, { frequency: formValues.frequency }]);
      setFrequencyDialogue(false);
    } else {
      toast(`Failed to ${'create'} Frequency master`, {
        variant: 'error'
      });
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
        <Grid item>
          <Typography fontWeight="bold" fontSize="14px" color="red">
            Add Frequency
          </Typography>
        </Grid>
        <TextField name="frequency" />
      </Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
